module.exports = __webpack_public_path__ + "media/St 4-light switch-question.01eaa509.wav";